module.exports = __webpack_public_path__ + "b0cc615c62d18d403d5d09a7836ce5ec.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/4_column_medium_x1/public/history/fi-1997.png
// module id = 379
// module chunks = 0